import ApiClient from 'common/ApiClient'

export default {
  methods: {
    async retrieveChildren(index, catid) {
      var api = new ApiClient()
      const response = await api.get(
        `${gon.url_for.navigation_index_search.replace(':id', index)}?catid=${catid}`
      )
      return this.sort(response.data) || []
    },

    sort(nodes) {
      return [...nodes].sort((a, b) => {
        const aLeaf = !!a.leaf
        const bLeaf = !!b.leaf
        if (aLeaf !== bLeaf) return aLeaf ? -1 : 1

        const aId = Number(a.catid)
        const bId = Number(b.catid)
        return aId - bId
      })
    }
  }
}
